<div class="print-wrapper">
  <div class="print-header">
    <img class="logo" src="./assets/image/invivo.png">
    <!--<table border="0" width="100%" style="margin-bottom: 16px">
      <tr>
        <td><img style="height: 65px;margin: auto;display: block" src="./assets/image/invivo.png"></td>
      </tr>
    </table>-->
    <div style="margin-bottom: 16px" style="margin-bottom: 16px;background: #F1F1F1;padding: 8px 0;">
      <h1 style="text-align: center; text-transform: uppercase;">Phòng xét nghiệm Invivolab</h1>
      <div style="text-align: center;">
        <p>Địa chỉ: 257B1 Giải Phóng, Phương Mai, Đống Đa, TP Hà Nội</p>
      </div>
      <div class="row-info">
        <p>Email: info@invivolab.vn</p>
        <span class="hoz-divider">|</span>
        <p>Website: invivolab.vn</p>
      </div>
    </div>
    <div>
      <h2 style="text-align: center;text-transform: uppercase;">Phiếu trả kết quả xét nghiệm</h2>
      <div class="barcode">
      </div>
    </div>
    <table border="0" width="100%">
      <tr>
        <td>Họ và tên</td>
        <td style="text-transform: uppercase;font-weight: bold">{{orderItem.patient.name}}</td>
        <td colspan="3">Năm sinh: {{orderItem.patient.dob | dateFormat: 'yyyy'}}   Giới
          tính: {{orderItem.patient.sex === 0 ? 'Nữ' : 'Nam'}}</td>
      </tr>
      <tr>
        <td>Địa chỉ</td>
        <td colspan="2">{{orderItem.patient.address}}</td>
        <td>Số điện thoại: {{orderItem.patient.phone}}</td>
        <td></td>
      </tr>
      <tr>
        <td>Bác sỹ chỉ định</td>
        <td colspan="2">{{orderItem.orderDoctor}}</td>
        <td>Đơn vị:</td>
        <td></td>
      </tr>
      <tr>
        <td>Chẩn đoán</td>
        <td colspan="2">{{orderItem.chanDoan}}</td>
        <td>Ghi chú: {{orderItem.note}}</td>
        <td></td>
      </tr>
    </table>
    <br>
    <table width="100%" class="table-result">
      <thead>
      <tr>
        <th width="30%">Xét nghiệm</th>
        <th>Kết quả</th>
        <th width="90px">Đơn vị</th>
        <th width="140px">Giá trị tham chiếu</th>
        <th width="100px">Ghi chú</th>
        <th width="140px">Máy XN/PP XN</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let group of groupResultValues">
        <tr>
          <td colspan="6" style="font-weight: bold;background: #fff9dc;">{{group.name.toUpperCase()}}</td>
        </tr>
        <ng-container *ngFor="let item of group.items">
          <tr [class]="toTdCls(item)">
            <td class="color-change">{{item.resultType.name}}</td>
            <td class="color-change">{{item.valueStr}}</td>
            <td>{{item.resultType.unitName}}</td>
            <td>
              <div *ngIf="item.resultType.unitType === 0">
                {{item.resultType.normalMin}} - {{item.resultType.normalMax}}
              </div>
            </td>
            <td></td>
            <td>
              {{item.machineName}}
            </td>
          </tr>
        </ng-container>
      </ng-container>
      </tbody>
    </table>
  </div>
</div>

<!-- <div class="print-content">

</div>
<div class="print-footer">

</div>
</div> -->
<!-- Footer -->
<!-- <div *nzModalFooter>
  <button nz-button (click)="handleCancel()">Đóng</button>
</div> -->
<!-- </nz-modal> -->
